import { Calendar } from 'lucide-react'

import { getLocaleDateString } from 'utils'

type CoverageDetailsSectionProps = {
  coverageStartDate: string
  requestedStartDate?: string
  headerVariant?: 'full' | 'compact'
}

const CoverageDetailsSection = ({
  coverageStartDate,
  requestedStartDate,
  headerVariant = 'full',
}: CoverageDetailsSectionProps) => {
  const headerText = headerVariant === 'full' ? 'Coverage Details:' : 'Details:'

  return (
    <div className='space-y-2'>
      <h6 className='font-medium text-sm text-gray-600'>{headerText}</h6>
      <div className='flex items-center space-x-2'>
        <Calendar className='w-4 h-4 text-blue-500' />
        <span className='text-sm text-gray-600'>
          Coverage starts {getLocaleDateString(new Date(coverageStartDate))}
        </span>
      </div>
      {requestedStartDate && (
        <div className='flex items-center space-x-2'>
          <Calendar className='w-4 h-4 text-amber-500' />
          <span className='text-sm text-gray-500'>
            Requested Start Date{' '}
            {getLocaleDateString(new Date(requestedStartDate))}
          </span>
        </div>
      )}
    </div>
  )
}

export default CoverageDetailsSection
